import React, { useState } from 'react'
import {  Form, Input, message, Modal } from 'antd'
import { useShangpinguigeAddMutation } from '../../store/dianshangtaizhangApi';
import { PlusOutlined } from '@ant-design/icons';
function GoodsSpecAdd(props) {
    const [form] = Form.useForm(); 
    const [submit] = useShangpinguigeAddMutation();
    const [info,setInfo] = useState({
        spgg_content: '',
        spgg_day: '',
        spgg_name: '',
        spgg_price: '',
        spgg_sp_id: '',
        spgg_sp_name: '',
        spgg_bianhao: '',
    })
    const [open, setOpen] = useState(false);
    return (
        <>
            <a onClick={() => {setOpen(true)}}><PlusOutlined /> 新增规格</a>
            <Modal
                open={open}
                title='新增规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submit({
                        "spgg_content" : info.spgg_content,
                        "spgg_day" : info.spgg_day,
                        "spgg_name" : info.spgg_name,
                        "spgg_price" : info.spgg_price,
                        "spgg_sp_id" : props.sp_id,
                        "spgg_sp_name" : props.sp_name,
                        'spgg_bianhao': info.spgg_bianhao,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}                                     
                >                                                       
                    <Form.Item name="spgg_sp_id" wrapperCol={{span:10}} required label='商品'>                        
                        {props.sp_name}
                    </Form.Item>           
                    <Form.Item name="spgg_name" wrapperCol={{span:10}} required label='规格名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_price" wrapperCol={{span:10}} required label='规格价格'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_price:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_day" wrapperCol={{span:10}} required label='天数'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_day:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_bianhao" wrapperCol={{span:10}} required label='编号'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_bianhao:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="spgg_content" wrapperCol={{span:10}} label='备注'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spgg_content:e.target.value}))
                        }}/>
                    </Form.Item>                                                                                 
                </Form>
            </Modal>
        </>
    )
}

export default GoodsSpecAdd